import React from 'react';
import type { FC } from 'react';
import { Link } from 'react-router-dom';
import PersonOutlineIcon from '@material-ui/icons/PersonOutline';
import { routes } from '@/constants';
import { SearchCard, SearchCardContent, SearchCardDetails, SearchCardIcon } from './Sidebar.styled';

interface Props {
  readonly customerId: string;
  readonly firstName: string;
  readonly lastName: string;
  readonly email: string;
  readonly phoneNumber: string;
}

const SidebarCustomerCard : FC<Props> = ({ customerId, firstName, lastName, email, phoneNumber }) => {
  const customerUrl = routes.customer(customerId);

  return (
    <Link to={customerUrl}>
      <SearchCard>
        <SearchCardIcon>
          <PersonOutlineIcon />
        </SearchCardIcon>

        <SearchCardContent>
          <div>
            { firstName } { lastName }
          </div>

          <SearchCardDetails>
            { email }
          </SearchCardDetails>

          <SearchCardDetails>
            { phoneNumber }
          </SearchCardDetails>
        </SearchCardContent>
      </SearchCard>
    </Link>
  );
};

export default SidebarCustomerCard;
